//since google redirect to the root, we use this hook as a WA

import React, { useEffect } from "react";
import { registerOnSignIn, socialLoginRedirectItem } from "./kahunUserAuth";

export const useSocialRedirect = (history) => {
  const [loading, setLoading] = React.useState(false);

  //A WA for redirecting to a non-root path after social login
  useEffect(() => {
    const redirect = sessionStorage.getItem(socialLoginRedirectItem);
    if (redirect) {
      setLoading(true);
      registerOnSignIn(() => {
        if (redirect) {
          sessionStorage.removeItem(socialLoginRedirectItem);
          setLoading(false);
          history.push(redirect);
        }
      });
    }
  }, [history]);

  return { loading };
};
